import React, { Component } from "react"
import { Segment, Container, Image, Table, Grid } from "semantic-ui-react"
import Icon from "react-icons-kit"
import "./CardOverview.css"
//import { connect } from "http2"
import translate from "../../../../node_modules/react-translate/lib/translate"

//const CardAccueil = ({titre, description, rules, square}) => (
class CardAccueil extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }
  render(titre, description, rules, square) {
    return (
      <div className="cardOverview">
        <div className="wrapper">
          <Container className="title">
            {/*<Icon size={20} className="titleIcon" icon={icon} />*/}
            {titre}
          </Container>
          <Container className="body">
            <Grid columns="equal">
              <Grid.Row className="cardLine">
                <Grid.Column width={16} className="cardLineColumn">
                  {description}
                </Grid.Column>
                <Grid.Column width={16} className="cardLineColumn">
                  {rules}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </div>
      </div>
    )
  }
}

export default translate("CardAccueil")(CardAccueil)



// WEBPACK FOOTER //
// ./src/components/Pro/Accueil/CardAcceuil.jsx